import { render } from "./RegistrationRoleSelect.vue?vue&type=template&id=e879f60c"
import script from "./RegistrationRoleSelect.vue?vue&type=script&lang=js"
export * from "./RegistrationRoleSelect.vue?vue&type=script&lang=js"

import "./RegistrationRoleSelect.vue?vue&type=style&index=0&id=e879f60c&lang=scss"

import exportComponent from "/var/www/html/gonapsacc-11/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__